'use client';

import { SvgWelloPoint } from '@common/icon';

import { useAdpopcorn } from '@/modules/adpopcorn';

import type { ShortcutActionRowProps } from './KosafHouseholdShortcutRow';

export const WelloPointRewardShortcutRow = ({
  label,
  onNavigate,
}: ShortcutActionRowProps) => {
  const { status, onClick, isOpening } = useAdpopcorn({ placement: 'MY_ENTRY' });

  if (status === 'unsupported') return null;

  const handleClick = () => {
    onClick();

    //* app-install/login 상태에서는 모달이 떠야 하므로 메뉴를 닫지 않는다.
    if (status === 'ready') {
      onNavigate?.();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isOpening}
      className="flex w-full items-center gap-8 px-20 py-12 text-left transition-colors hover:bg-Gray-50 disabled:opacity-60"
    >
      <SvgWelloPoint originalFill className="size-24 shrink-0" />
      <span className="line-clamp-1 font-500 text-Gray-900 typo-body3">
        {label}
      </span>
    </button>
  );
};
